import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { dvbar as dvbarData } from 'app/mock-api/dashboards/dv-bar/data';
import { cloneDeep } from 'lodash-es';

@Injectable({providedIn: 'root'})
export class DataVisualBarMockApi
{
    private _dvbar: any = dvbarData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/dashboards/dv-bar')
            .reply(() => [200, cloneDeep(this._dvbar)]);
    }
}
